<template>
  <div>
    <Loader :isVisible.sync="isloader" :text="'Carregando'" />

    <div :class="containerClass" @click="onWrapperClick">
      <AppTopBar @menu-toggle="onMenuToggle" />
      <div class="layout-sidebar layout-sidebar-light" @click="onSidebarClick">
        <div class="layout-logo">
          <router-link :to="{ path: `/${APP_BASE_URL}` }">
            <img alt="seplag" src="./assets/LOGO SEPLAG - BRANCO VAZADO.svg"  style="width: 13rem;"/>
          </router-link>
        </div>
        <AppProfile :ontrocarSenha="trocarSenha" />
        <AppMenu :model.sync="menu" @menuitem-click="onMenuItemClick" />
        <!-- <div style="width:100%; text-align:center; position:absolute; bottom:2px; color:#CCC" v-if="process.env.VUE_APP_VERSAO">{{process.env.VUE_APP_VERSAO}}</div> -->
        <div
          style="
            width: 100%;
            text-align: center;
            position: absolute;
            bottom: 2px;
            color: #ffffff;
          "
        >
          {{ VersaoFront }} - {{ versaoAPI }}
        </div>
      </div>

      <div class="layout-main" v-if="isUserLogado">
        <router-view />
        <cadastro-rapido
          tituloTela="Trocar a Senha"
          v-model="exibirTelaTrocarSenha"
          :modoEdicao="modoEdicao"
          :onAlterar="atualizarSenha"
          :visivelFechar="visivelFecharTela"
          v-if="exibirTelaTrocarSenha"
          :textoButton="'Alterar'"
        >
          <Rotulo nome="Senha Atual" cols="12">
            <InputText
              type="password"
              v-model="registroLogin.senhaAtual"
              v-required
            />
          </Rotulo>
          <Rotulo nome="Nova Senha" cols="12">
            <InputText
              type="password"
              v-model="registroLogin.senhaNova"
              v-required
            />
          </Rotulo>
          <Rotulo nome="Confirma Nova Senha" cols="12">
            <InputText
              type="password"
              v-model="registroLogin.confirmarSenha"
              v-required
            />
          </Rotulo>
        </cadastro-rapido>
      </div>

      <AppFooter />
    </div>

    <Redirect v-if="!isUserLogado" name="auth" />
  </div>
</template>

<script>
import AppTopBar from "./AppTopbar.vue";
import AppProfile from "./AppProfile.vue";
import AppMenu from "./AppMenu.vue";
import AppFooter from "./AppFooter.vue";
import { mapGetters } from "vuex";
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import Loader from "@/paginas/Loader.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import Redirect from "@/template/Redirect.vue";
import { baseApiUrl, perfisAdm, getVersaoFront } from "@/config/global";
// import router from "@/config/router";

const getDefaultState = () => {
  return {
    // id: '',
    login: "",
    senhaAtual: "",
    senhaNova: "",
    confirmarSenha: "",
  };
};

export default {
  data() {
    return {
      layoutMode: "static",
      layoutColorMode: "dark",
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      exibirTelaTrocarSenha: false,
      visivelFecharTela: true,
      fecharMenuProfile: false,
      loaderTrue: false,
      modoEdicao: "alterar",
      registroLogin: getDefaultState(),
      vinculos: null,
      registroVinculo: null,
      user: null,
      menu: null,
      versaoAPI: "",
      VersaoFront: 0,
      APP_BASE_URL: process.env.VUE_APP_BASE_URL,
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      // this.$toast.removeAllGroups();
    },
    isLoader(newLoader) {
      this.loaderTrue = newLoader;
    },
    isExisteUser(novaresposta, antigaResposta) {
      if (novaresposta != antigaResposta && novaresposta) {
        this.menu = [
          {
            label: "Tela Inicial",
            icon: "pi pi-fw pi-home",
            to: "/" + process.env.VUE_APP_BASE_URL,
          },
        ];

        let items = [];

        if (this.isUserTemPerssao("seguranca")) {
          if (this.isUserTemPerssao("cadastroUsuario")) {
            items.push({
              label: "Usuário",
              to: `/${process.env.VUE_APP_BASE_URL}/cadastro/usuario`,
            });
          }

          if (this.isUserTemPerssao("cadastroExercicio")) {
            items.push({
              label: "Exercicio",
              to: `/${process.env.VUE_APP_BASE_URL}/cadastro/exercicio`,
            });
          }

          if (this.isUserTemPerssao("cadastroPerfilUsuario")) {
            items.push({
              label: "Perfil",
              to: `/${process.env.VUE_APP_BASE_URL}/cadastro/usuario`,
            });
          }

          this.menu.push({
            label: "Adm Central",
            icon: "pi pi-fw pi-users",
            items,
          });
        }

        if (this.isUserTemPerssao("fiscalizacao")) {
          this.menu.push({
            label: "Fiscalização",
            to: `/${process.env.VUE_APP_BASE_URL}/fiscalizacao`,
          });
        }

        if (this.isUserTemPerssao("auditoria")) {
          this.menu.push({
            label: "Auditoria",
            icon: "pi pi-fw pi-users",
            to: `/${process.env.VUE_APP_BASE_URL}/log/auditoria`,
          });
        }
      } else {
        this.menu = [
          {
            label: "Tela Inicial",
            icon: "pi pi-fw pi-home",
            to: "/" + process.env.VUE_APP_BASE_URL,
          },
        ];
      }
    },
    isRefreshMenu(novaresposta, antigaResposta) {
      if (novaresposta != antigaResposta && novaresposta) {
        this.criarMenu();
        this.$store.commit("setIsRefreshMenu", false);
      }
    },
  },
  methods: {
    validateToken() {
      var dataToken = null;

      // if (localStorage.getItem(process.env.VUE_APP_USER_KEY)) {
      //   dataToken = JSON.parse(
      //     atob(localStorage.getItem(process.env.VUE_APP_USER_KEY))
      //   );
      // }

      if (localStorage.getItem(process.env.VUE_APP_USER_KEY)) {
        let dadosStorageSeplagJson = decodeURI(
          atob(localStorage.getItem(process.env.VUE_APP_USER_KEY))
        );
        dataToken = JSON.parse(dadosStorageSeplagJson);
      }

      if (dataToken) {
        if (!this.$store.getters.isUserLogado) {
          this.$store.commit("setUserLogado", true);
        }

        if (!this.$store.getters.getToken) {
          this.$store.commit("setToken", dataToken.token);
        }
        if (!this.$store.getters.getUser) {
          this.$store.dispatch("buscarUsuario", this);
        }
      }
    },
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          this.overlayMenuActive = !this.overlayMenuActive;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    atualizarSenha() {
      // this.registroLogin.id = this.$store.getters.getUser.contaAcesso.id
      this.registroLogin.login = this.$store.getters.getUser.contaAcesso.login;
      this.$http
        .put(
          `${baseApiUrl}/seguranca/contasacesso/senha/${this.$store.getters.getUser.contaAcesso.id}`,
          JSON.stringify(this.registroLogin)
        )
        .then((res) => {
          this.$toast.add({
            severity: "success",
            summary: res.data,
            life: 3000,
          });
          this.$store.dispatch("buscarUsuario", this);
          this.exibirTelaTrocarSenha = false;
        })
        .catch((error) => {
          for (let i = 0; i < error.response.data.length; i++) {
            this.$toast.add({
              severity: "error",
              summary: error.response.data[i].msgUsuario,
              life: 3000,
            });
          }
        });
    },
    trocarSenha() {
      this.exibirTelaTrocarSenha = true;
      this.visivelFecharTela = true;
      this.registroLogin = getDefaultState();
    },
    asUser() {
      if (
        this.$store.getters.getUser &&
        this.$store.getters.getUser.trocarSenha == "S"
      ) {
        this.exibirTela = true;
        this.visivelFecharTela = false;
        this.registroLogin = getDefaultState();
        this.registroLogin.id = this.$store.getters.getUser.id;
        this.registroLogin.login = this.$store.getters.getUser.login;
      }
    },
    interageLoder(loader) {
      this.loaderTrue = loader;
    },
    beforeUpdate() {
      if (this.mobileMenuActive)
        this.addClass(document.body, "body-overflow-hidden");
      else this.removeClass(document.body, "body-overflow-hidden");
    },
    isUserTemPerssao(nomerota) {
      let perfilUsers =
        this.$store.getters.getUser.contaAcesso.direitosDinamicos;
      let possuiAcesso = false;
      // if( perfilUsers.length <= 0){
      //     let verifica = paginasChefia.filter(function (element){
      //         return element == nomerota
      //     })

      //     if(!verifica || verifica.length <= 0){
      //         possuiAcesso = true
      //     }
      // } else{

      for (let i = 0; i < perfilUsers.length; i++) {
        let permissao = perfisAdm.filter(function (element) {
          return element.perfil == perfilUsers[i].nomeRole;
        });
        if (permissao.length > 0) {
          let verifica = permissao[0].permissoes.filter(function (element) {
            return element == nomerota;
          });
          if (verifica && verifica.length > 0) {
            possuiAcesso = true;
            break;
          }
        }
        // }
      }
      //VALIDACAO AUTORIDADES
      perfilUsers = this.$store.getters.getUser.contaAcesso.authorities;
      if (perfilUsers && perfilUsers.length > 0) {
        for (let i = 0; i < perfilUsers.length; i++) {
          let permissao = perfisAdm.filter(function (element) {
            return element.perfil == perfilUsers[i].nomeRole;
          });
          if (permissao.length > 0) {
            let verifica = permissao[0].permissoes.filter(function (element) {
              return element == nomerota;
            });
            if (verifica && verifica.length > 0) {
              possuiAcesso = true;
              break;
            }
          }
        }
      }
      return possuiAcesso;
    },
    criarMenu() {
      this.menu = [
        {
          label: "Tela Inicial",
          icon: "pi pi-fw pi-home",
          to: "/" + process.env.VUE_APP_BASE_URL,
        },
      ];

      let items = [];

      if (this.isUserTemPerssao("seguranca")) {
        if (this.isUserTemPerssao("cadastroUsuario")) {
          items.push({
            label: "Usuário",
            to: `/${process.env.VUE_APP_BASE_URL}/cadastro/usuario`,
          });
        }

        /*if (this.isUserTemPerssao("atribuirAcessoFiscal")) {
          items.push({
            label: "Acesso Fiscalizador",
            to: `/${process.env.VUE_APP_BASE_URL}/cadastro/acesso/fiscal`,
          });
        }*/

        if (this.isUserTemPerssao("cadastroExercicio")) {
          items.push({
            label: "Exercício",
            to: `/${process.env.VUE_APP_BASE_URL}/cadastro/exercicio`,
          });
        }

        if (this.isUserTemPerssao("cadastroPerfilUsuario")) {
          items.push({
            label: "Perfil",
            to: `/${process.env.VUE_APP_BASE_URL}/cadastro/perfil`,
          });
        }

        this.menu.push({
          label: "Adm Central",
          icon: "pi pi-fw pi-users",
          items,
        });
      }

      items = [];

      if (this.isUserTemPerssao("RH")) {
        /* if (this.isUserTemPerssao("gerenciaValidacao")) {
          items.push({
            label: "Validar Arquivos",
            to: `/${process.env.VUE_APP_BASE_URL}/modulo-rh/validarArquivo`,
          });
        } */

        if (this.isUserTemPerssao("gerenciaValidacao")) {
          items.push({
            label: "Acompanhar Declarações",
            to: `/${process.env.VUE_APP_BASE_URL}/modulo-rh/acompanharDeclaracao`,
          });
        }

        if (this.isUserTemPerssao("retificacao")) {
          items.push({
            label: "Retificar Declarações",
            to: `/${process.env.VUE_APP_BASE_URL}/modulo-rh/retificacao/lista`,
          });
        }

        this.menu.push({
          label: "Gestor",
          icon: "pi pi-fw pi-users",
          items,
        });
      }

      if (this.isUserTemPerssao("fiscalizacao")) {
        this.menu.push({
          label: "Fiscalização",
          icon: "pi pi-fw pi-briefcase",
          to: `/${process.env.VUE_APP_BASE_URL}/fiscalizacao`,
        });
      }

      if (this.isUserTemPerssao("relatorio")) {
        items = [];

        if (this.isUserTemPerssao("relatorioConsolidado")) {
          items.push({
            label: "Consolidado Por Órgão",
            to: `/${process.env.VUE_APP_BASE_URL}/relatorio/consolidado/orgao`,
          });

          items.push({
            label: "Consolidado Por Vínculo",
            to: `/${process.env.VUE_APP_BASE_URL}/relatorio/consolidado/vinculo`,
          });
        }

        this.menu.push({
          label: "Relatório",
          icon: "pi pi-fw pi-file-pdf",
          items,
        });
      }

      if (this.isUserTemPerssao("auditoria")) {
        items = [];

        if (this.isUserTemPerssao("auditoria")) {
          items.push({
            label: "Log Auditoria",
            to: `/${process.env.VUE_APP_BASE_URL}/log/auditoria`,
          });
        }

        this.menu.push({
          label: "Auditoria",
          icon: "pi pi-fw pi-users",
          items,
        });
      }
    },
    //  async getVersaoFront(){
    //   let versao = await this.$http.get(`${baseApiUrl}/publicosdb/frontend/versao`)

    //   if(versao.status == 200){

    //     let LocalStorageSeplag = localStorage.getItem(process.env.VUE_APP_USER_KEY)
    //     let storageSeplagJson = JSON.parse(atob(LocalStorageSeplag))

    //     let versaoAtual = storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].versaoFront ? storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].versaoFront : null

    //     if(!versaoAtual || versaoAtual != versao.data){

    //       storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].versaoFront = versao.data

    //       localStorage.setItem(
    //         process.env.VUE_APP_USER_KEY,
    //         btoa(JSON.stringify(storageSeplagJson))
    //       );

    //       window.location.reload()
    //     }

    //     this.VersaoFront = versaoAtual

    //   }
    // }
  },
  created() {
    this.validateToken();
    this.criarMenu();

    getVersaoFront().then((res) => {
      this.VersaoFront = res;
    });
  },
  computed: {
    ...mapGetters(["isUserLogado", "isloader", "getIsRefreshMenu"]),
    containerClass() {
      if (!this.isUserLogado) {
        return [
          "layout-wrapper",
          {
            "layout-overlay": this.layoutMode === "overlay",
            "layout-static": this.layoutMode === "static",
            "layout-static-sidebar-inactive": true,
            "layout-overlay-sidebar-active":
              this.overlayMenuActive && this.layoutMode === "overlay",
            "layout-mobile-sidebar-active": this.mobileMenuActive,
          },
        ];
      } else {
        return [
          "layout-wrapper",
          {
            "layout-overlay": this.layoutMode === "overlay",
            "layout-static": this.layoutMode === "static",
            "layout-static-sidebar-inactive":
              this.staticMenuInactive && this.layoutMode === "static",
            "layout-overlay-sidebar-active":
              this.overlayMenuActive && this.layoutMode === "overlay",
            "layout-mobile-sidebar-active": this.mobileMenuActive,
          },
        ];
      }
    },
    sidebarClass() {
      return [
        "layout-sidebar",
        {
          "layout-sidebar-dark": this.layoutColorMode === "dark",
          "layout-sidebar-light": this.layoutColorMode === "light",
        },
      ];
    },
    logo() {
      //return (this.layoutColorMode === 'dark') ? "assets/layout/images/logo-white.svg" : "assets/layout/images/logo.svg";
      return "assets/seplag.png";
    },
    isLoader() {
      return this.isloader;
    },
    isExisteUser() {
      return this.$store.getters.getUser ? true : false;
    },
    isRefreshMenu() {
      return this.getIsRefreshMenu;
    },
  },
  components: {
    AppTopBar: AppTopBar,
    AppProfile: AppProfile,
    AppMenu: AppMenu,
    AppFooter: AppFooter,
    Loader: Loader,
    Rotulo,
    CadastroRapido,
    Redirect,
  },
  mounted() {
    this.$http.get(`${baseApiUrl}/publicos/sistemas/versao`).then((res) => {
      this.versaoAPI = res.data;
    });
    // versao().then(resp => this.versaoFront = resp)
  },
};
</script>

<style lang="scss">
@import "./App.scss";
</style>